import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const DataLabelingPrivateRoute = ({ children }) => {
  const user = useSelector((state) => state.user);

  // Check if user has the specific permission
  const hasDataLabelingPermission =
    user.permissions?.can_label_data || user.permissions?.can_clean_data;

  if (!hasDataLabelingPermission) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default DataLabelingPrivateRoute;
